// HeroCard.tsx
import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import './HeroCard.scss';
import { NavLink } from 'react-router-dom';
import { AiMagicIcon } from 'hugeicons-react';

const { Title, Paragraph } = Typography;

const HeroCard: React.FC = () => (
  <div className="hero-card">
    <Title level={2} className="hero-card__title">
      Öğrenmeyi Kolaylaştıran Asistanın Hazır
    </Title>
    <Paragraph className="hero-card__desc">
      Ders çalışırken takıldığında SaHa AI hep yanında!
      Sana özel anlatır, örneklerle açıklar, hızla kavratır.
      Ezberlemeden, anlayarak öğren.
    </Paragraph>
    <Space size="middle" className="hero-card__actions">
      <NavLink to="/ai-assistant" >
        <Button type="primary" size="large" icon={<AiMagicIcon />}>
          Denemeye Başla
        </Button>
      </NavLink>
      <NavLink to="/course" >
        <Button type="default" style={{ border: "2px solid #723fe7", color: "#723fe7" }} size="large">Kursa Katıl</Button>
      </NavLink>
    </Space>
  </div>
);

export default HeroCard;
